module.exports = __webpack_public_path__ + "img/logo-ebsa-fonte-azul.e5680855.svg";